module.exports = __webpack_public_path__ + "assets/img/wh8.1fd34b4f.png";